import {useAppSelector} from '@app/redux/reduxHooks';
import {userSelector} from '@app/redux/slices/userSlice';

export const usePaymentMethod = () => {
  const paymentMethod = useAppSelector(userSelector)?.payment?.method;
  return paymentMethod;
};
